"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _constants = require("./constants");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  required: false
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchTwoFactorRequiredEnforcementActionTypes.SUCCESS, function (state, action) {
  return state.set('required', action.payload.data === _constants.TwoFactorRequiredEnforcement.REQUIRED);
}), (0, _defineProperty2.default)(_handleActions, _actions.SetTwoFactorNotRequiredActionTypes.SUCCESS, function (state) {
  return state.set('required', false);
}), (0, _defineProperty2.default)(_handleActions, _actions.SetTwoFactorRequiredActionTypes.SUCCESS, function (state) {
  return state.set('required', true);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;